// ============================================================================
// DropdownMulti.jsx — Corelia v1.2 (FormLayout + thème 100% form)
// ============================================================================
import React, { useState, useEffect, useRef } from "react";
import theme from "../../../styles/theme";
import FormLayout from "./FormLayout";

const ChevronUp = "/assets/icones/chevron-up.svg";

const DropdownMulti = ({
  label,
  labelPosition = "left",
  labelWidth = null,
  align = "center",
  options = [],
  selectedValues = [],
  onChange,
  placeholder = "Sélectionner...",
  disabled = false,
  width = "100%",
  optionPaddingY = theme.spacing.sm,
  style = {},
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  // ==========================================================================
  // Fermeture automatique — clic extérieur
  // ==========================================================================
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ==========================================================================
  // Fermeture automatique — touche ESC
  // ==========================================================================
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", handleKey);
    return () =>
      document.removeEventListener("keydown", handleKey);
  }, []);

  // ==========================================================================
  const toggleOption = (value) => {
    if (disabled) return;

    const exists = selectedValues.includes(value);
    const newValues = exists
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];

    onChange(newValues);
  };

  const toggleSelectAll = () => {
    if (disabled) return;

    if (selectedValues.length === options.length) {
      onChange([]);
    } else {
      onChange(options.map((o) => o.value));
    }
  };

  const displayText =
    selectedValues.length > 0
      ? selectedValues
          .map((v) => options.find((o) => o.value === v)?.label ?? v)
          .join(", ")
      : placeholder;

  // ==========================================================================
  return (
    <FormLayout
      label={label}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      align={align}
      width={width}
      style={style}
    >
      <div ref={wrapperRef} style={{ position: "relative", width: "100%", marginTop: 8, marginLeft: 8 }}>
        {/* SELECT BOX -------------------------------------------------------- */}
        <div
          onClick={() => !disabled && setOpen(!open)}
          style={{
            width: "100%",
            minHeight: theme.form.field.minHeight,
            padding: `${theme.form.field.paddingV}px ${theme.form.field.paddingH}px`,

            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            borderRadius: theme.form.field.borderRadius,
            border: theme.form.field.border,
            backgroundColor: disabled
              ? theme.form.disabled.background
              : theme.form.field.background,

            cursor: disabled ? "not-allowed" : "pointer",
            transition: theme.form.field.transition,
            boxSizing: "border-box",

            fontFamily: theme.form.label.fontFamily,
            fontSize: theme.form.label.fontSize,
            //fontWeight: theme.form.field.fontWeight,
            // color:
            //   selectedValues.length > 0
            //     ? theme.form.field.color
            //     : theme.form.placeholder,

            // fontStyle:
            //   selectedValues.length > 0 ? "normal" : "italic",

            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          <span
            style={{
              fontFamily: theme.form.field.fontFamily,
              fontSize: theme.form.field.fontSize,
              //fontWeight: theme.form.field.fontWeight,
              color: selectedValues.length > 0 ? theme.form.field.color : theme.form.placeholder,
              fontStyle: selectedValues.length > 0 ? "normal" : "italic",
            }}
          >
            {displayText}
          </span>

          <img
            src={ChevronUp}
            alt="chevron"
            style={{
              width: 14,
              height: 14,
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
              opacity: disabled ? 0.4 : 0.8,
            }}
          />
        </div>

        {/* LISTE DÉROULANTE ------------------------------------------------- */}
        {open && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              marginTop: 2,
              width: "100%",

              maxHeight: 220,
              overflowY: "auto",

              borderRadius: theme.form.field.borderRadius,
              border: theme.form.field.border,
              backgroundColor: theme.form.field.background,
              boxShadow: theme.form.shadows.xs,
              zIndex: 9999,
            }}
          >
            {/* SELECT ALL */}
            <div
              onClick={toggleSelectAll}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: `${optionPaddingY}px ${theme.spacing.md}px`,

                fontFamily: theme.form.field.fontFamily,
                fontSize: theme.form.field.fontSize,
                

                backgroundColor: theme.colors.background.muted,
                cursor: "pointer",
                borderBottom: theme.form.field.border,
              }}
            >
              <input
                type="checkbox"
                checked={
                  selectedValues.length === options.length &&
                  options.length > 0
                }
                readOnly
                style={{
                  cursor: "pointer",
                  accentColor: theme.colors.text.success,
                }}
              />
              
                {selectedValues.length === options.length ? "Tout désélectionner" : "Tout sélectionner"}
              
            </div>

            {/* OPTIONS */}
            {options.map((opt) => {
              const checked = selectedValues.includes(opt.value);

              return (
                <div
                  key={opt.value}
                  onClick={() => toggleOption(opt.value)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,

                    padding: `${optionPaddingY}px ${theme.spacing.md}px`,
                    cursor: "pointer",

                    fontFamily: theme.form.field.fontFamily,
                    fontSize: theme.form.field.fontSize,
                    color: theme.form.field.color,

                    backgroundColor: checked
                      ? theme.colors.background.muted
                      : "transparent",

                    transition: "background-color 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      theme.colors.background.muted)
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      checked
                        ? theme.colors.background.muted
                        : "transparent")
                  }
                >
                  <input
                    type="checkbox"
                    checked={checked}
                    readOnly
                    style={{
                      cursor: "pointer",
                      accentColor: theme.colors.text.success,
                    }}
                  />
                  
                    {opt.label}
                  
                </div>
              );
            })}
          </div>
        )}
      </div>
    </FormLayout>
  );
};

export default DropdownMulti;
